module.exports = __webpack_public_path__ + "img/male.a2d8b253.svg";